import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function GoogleAuthSuccess() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const qs = new URLSearchParams(location.search);

    const token = qs.get("token");
    const name = qs.get("name");
    const email = qs.get("email");
    const picture = qs.get("picture");

    if (token) {
      localStorage.setItem("clientToken", token);
      localStorage.setItem(
        "clientUser",
        JSON.stringify({
          fullName: name || "",
          email: email || "",
          pictureUrl: picture || "",
        })
      );
    }

    const returnUrl = sessionStorage.getItem("postGoogleReturnUrl") || "/";
    navigate(returnUrl, { replace: true });
  }, [location.search, navigate]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="bg-white border border-gray-100 rounded-3xl shadow-xl p-8 text-center max-w-md w-full">
        <div className="mx-auto mb-4 h-12 w-12 rounded-full border-4 border-blue-200 border-t-blue-600 animate-spin" />
        <h1 className="text-xl font-semibold text-gray-900">Signing you in</h1>
        <p className="text-sm text-gray-500 mt-2">
          Please wait a moment...
        </p>
      </div>
    </div>
  );
}

export default GoogleAuthSuccess;